import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useMemo } from "react";
import { TAccount } from "../../../../api/v1_0";
import { useStore } from "../../../../store";
import { IncomeSource } from "./_dependencies";
import { IIncomeSourcesProps } from "./types";

export const IncomeSources: FunctionComponent<IIncomeSourcesProps> = observer(
  (props: IIncomeSourcesProps): ReactElement<IIncomeSourcesProps> => {
    const { addAccount, closeAccount, openAccount, ...restProps } = props;
    const store = useStore();
    const incomeSources: Array<TAccount> = useMemo(
      () =>
        [...store.wallet.incomeSources.values()].map((incomeSource) => ({
          ...incomeSource,
          balance:
            store.operations.accounts.get(incomeSource.uuid)?.amount || 0,
        })),
      [store.wallet.accounts, store.operations.accounts]
    );

    return (
      <div className="contentBox marginBottom whiteBlockBg">
        <div className="contentBoxHeader">
          <h3>Источники дохода</h3>
          {false && (
            <a href="#" className="link" onClick={addAccount}>
              Добавить
            </a>
          )}
        </div>
        <div className="row">
          {incomeSources.map((incomeSource) => (
            <IncomeSource
              key={incomeSource.uuid}
              incomeSource={incomeSource}
              onPress={openAccount}
            />
          ))}
        </div>
      </div>
    );
  }
);
